// Můj účet — osobní nastavení přihlášeného člověka (28.9.2026, hlášení #121).
//
// Zatím jediná věc: propojení Slacku pro status 🌴 během dovolené. Dřív to byl
// barevný blok přímo v menu, který překřičel všechno ostatní. Teď je v menu jen
// řádek Můj účet a nastavení bydlí tady, v obyčejné kartě podle design systému.
// Další osobní nastavení (notifikace, podpis) sem půjde přidat jako další karta.
// 22.10.2026 FW-BOTI etapa 4: karta Změny od botů (jen owner a lidé s tokenem bota).
import React from "react";
import { UserCog } from "lucide-react";
import GradientHeader from "../components/GradientHeader.jsx";
import { Stranka } from "../components/ui.jsx";
import { SlackKarta } from "../components/SlackStatus.jsx";
import ZmenyBotuKarta from "../components/ZmenyBotuKarta.jsx";
import { getCurrentUser } from "../lib/auth.js";

export default function MujUcet() {
  const user = getCurrentUser();
  return (
    <Stranka sirka="uzka">
      <GradientHeader
        icon={UserCog}
        eyebrow="Účet"
        title="Můj účet"
        napoveda="Osobní nastavení, která platí jen pro tebe."
      />
      <SlackKarta jmeno={user?.name || ""} />
      <ZmenyBotuKarta />
    </Stranka>
  );
}
